import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class UrlParserService {
	constructor(private location: Location) {}

	getBasePath(): string {
		return this.getBasePathFromPath(this.location.path());
	}

	getBasePathFromUrl(urlOrPath: string): string {
		if (!urlOrPath) {
			return '';
		}
		try {
			// Supports both absolute URLs and plain paths.
			const parsed = new URL(urlOrPath, 'http://_');
			return this.getBasePathFromPath(parsed.pathname);
		} catch {
			return this.getBasePathFromPath(urlOrPath);
		}
	}

	private getBasePathFromPath(path: string): string {
		const safePath = path ?? '';
		const pathParts = safePath.split('/');

		const keywords = ['listing', 'showcase', 'search'];
		const index = pathParts.findIndex(p => keywords.includes(p));

		return index >= 0 ? pathParts.slice(0, index).join('/') : safePath;
	}
}
